<template>
  <app-dialog class="text-center" @close="close">
    <template #title>🎼 New Score 🎼</template>
    <v-col :cols="12">
      <span class="heading">Choose Your Setup...</span>
    </v-col>
    <v-col :cols="12" class="field pa-4">
      <app-drop-down-menu setting="key"
                          :options="pitchClasses"
                          :currently-selected="key"
                          text="Key: "
                          @updated="setState"/>
    </v-col>
    <v-col :cols="12" class="field pa-4">
      <app-drop-down-menu setting="scale"
                          :options="scales"
                          :currently-selected="scale.n"
                          @updated="setState"
                          text="Scale: "
                          map-by="n"/>
    </v-col>
    <v-col cols="12">
      <v-text-field flat v-model="scoreName"/>
    </v-col>
    <v-col :cols="12" class="pa-12">
      <v-btn fab large class="title"
             @click="goToComposer">
        Go !
      </v-btn>
    </v-col>
  </app-dialog>
</template>

<script>
  import { mapActions, mapGetters }                                          from 'vuex'
  import scales                                                              from 'assets/json/common-scale-ref'
  import { DRUMS }                                                           from 'misc/Constants'
  import { createScale, createScore, generateRandomScoreName, getConstants } from 'helpers/note-art-helpers'

  export default {
    name: 'TheNewScoreDialog',

    components: {
      AppDropDownMenu: () => import(/* webpackChunkName: "components" */ 'components/AppDropDownMenu'),
      AppDialog:       () => import(/* webpackChunkName: "app-main" */ 'components/AppDialog'),
    },

    data() {
      return {
        key:          'C',
        scale:        scales[0],
        scales:       scales,
        pitchClasses: getConstants().pitchClasses,
        scoreName:    '',
      }
    },

    created() {
      if(process.env.NODE_ENV != 'production') {
        setTimeout(() => {
          this.goToComposer()
        }, 300)
      }
      this.scoreName = this.generateScoreName()
    },

    computed: {
      ...mapGetters('transport', ['getScore', 'getNumberOfPlayers', 'getPlayerNames']),
      ...mapGetters('context', ['getPitch']),
    },

    methods: {
      ...mapActions('transport', ['setupGlobalScore']),
      ...mapActions('context', ['setPitchClass']),
      goToComposer() {
        this.setPitchClass(this.key)
        const { p, n, a } = this.scale
        const scale       = createScale(this.key, p, { name: n, aka: a })
        const voiceNames  = this.getPlayerNames.filter(name => name != DRUMS)
        const score       = createScore({ name: this.scoreName, voiceNames })
        this.setupGlobalScore({ scale, score })
        this.$emit('close', true)
      },

      close() {
        if(this.getScore) {
          this.$emit('close')
        } else {
          this.$router.go(-1)
        }
      },

      setState({ setting, value }) {
        this[setting] = value
        this.scoreName     = this.generateScoreName()
      },

      generateScoreName() {
        return generateRandomScoreName(this.key, this.scale.n)
      },
    },
  }
</script>

<style scoped>
  .field {
    border-bottom: 2px solid;
    border-top:    1px solid;
    border-radius: 7%;
  }
</style>
